import {MenuItem, TextField, TextFieldProps} from '@mui/material';
import {Box} from '@mui/system';

import {COLORED_ICONS, iconName} from '../../utils/icons';

export const MACHINE_TYPE_ICON_OPTIONS = [
  {
    value: 'default',
    name: 'Default (standard)',
    thumb: COLORED_ICONS[iconName.ASSET].blue,
  },
  {
    value: 'rtg',
    name: 'RTG',
    thumb: COLORED_ICONS[iconName.RTG].blue,
  },
  {
    value: 'reachStacker',
    name: 'Reach Stacker',
    thumb: COLORED_ICONS[iconName.REACH_STACKER].blue,
  },
  {
    value: 'forklift',
    name: 'Forklift',
    thumb: COLORED_ICONS[iconName.FORKLIFT].blue,
  },
];

type Props = TextFieldProps;

export const IconSelect = (props: Props) => {
  return (
    <TextField label="Icon" {...props} value={props.value ?? 'default'} select>
      {MACHINE_TYPE_ICON_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              component="img"
              src={option.thumb}
              height={24}
              sx={{imageRendering: 'pixelated'}}
            />
            {option.name}
          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
};
